// Two-button toggle between job-level and spool-level views.
// Surfaced on the Board and List views where both modes exist; the
// other views (Gantt / Bays / Cutting / Resource) are inherently
// job-driven and skip the toggle.
import { useSearchParams } from "react-router";

export type EntityMode = "jobs" | "spools";

interface Props {
  active: EntityMode;
}

export function EntityToggle({ active }: Props) {
  const [params, setParams] = useSearchParams();
  const set = (mode: EntityMode) => {
    const next = new URLSearchParams(params);
    if (mode === "spools") next.delete("entity");
    else next.set("entity", mode);
    setParams(next, { replace: true });
  };
  return (
    <div className="entity-toggle" role="tablist" aria-label="Entity mode">
      <button
        type="button"
        className={`entity-toggle-btn ${active === "jobs" ? "active" : ""}`}
        role="tab"
        aria-selected={active === "jobs"}
        onClick={() => set("jobs")}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
        Jobs
      </button>
      <button
        type="button"
        className={`entity-toggle-btn ${active === "spools" ? "active" : ""}`}
        role="tab"
        aria-selected={active === "spools"}
        onClick={() => set("spools")}
      >
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
          <circle cx="12" cy="12" r="9" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <path d="M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" />
        </svg>
        Spools
      </button>
    </div>
  );
}
